// extracted by mini-css-extract-plugin
export default {"arrowIcon":"a35_r","arrowIconOpened":"b35_r"};